import React from "react";
import { Root, PageNumber } from "./styles";

type PageBreakPluginProps = {
  componentConfig: {
    $id?: string;
    config?: {
      pageNumber?: string;
      cssClass?: string;
    };
  };
};

export const PageBreakPluginComponent: React.FC<PageBreakPluginProps> = ({ componentConfig }) => {
  const { $id } = componentConfig ?? {};
  const { pageNumber, cssClass } = componentConfig?.config ?? {};

  if (!pageNumber) return null;

  return (
    <Root className={cssClass ?? ""}>
      <PageNumber data-id={$id} data-page-number={pageNumber}>
        {pageNumber}
      </PageNumber>
    </Root>
  );
};
